/** Cookie holding the last measured banner height in px. Short-lived so a stale reservation self-heals. */
export const HOME_BANNER_HEIGHT_COOKIE = 'ctHomeBannerH'

/** Days the remembered height is kept — targeted users refresh it each visit; others let it expire. */
export const HOME_BANNER_HEIGHT_TTL_DAYS = 1

/** Sanity bound so a malformed cookie can never reserve an absurd amount of space. */
export const HOME_BANNER_MAX_RESERVED_HEIGHT = 400
